document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('nav_desktop_partners_btn');
    if (!btn) return;

    const wrapper = btn.closest('.relative');
    const panel = wrapper ? wrapper.querySelector('.dropdown-panel') : null;
    if (!panel) return;

    // open/close on click
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        const open = !panel.classList.contains('hidden');
        panel.classList.toggle('hidden', open);
        btn.setAttribute('aria-expanded', String(!open));
    });

    // close when clicking outside
    document.addEventListener('click', (e) => {
        if (!panel.classList.contains('hidden')) {
            if (!wrapper.contains(e.target)) {
                panel.classList.add('hidden');
                btn.setAttribute('aria-expanded', 'false');
            }
        }
    });

    // close on Esc
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !panel.classList.contains('hidden')) {
            panel.classList.add('hidden');
            btn.setAttribute('aria-expanded', 'false');
            btn.focus();
        }
    });
});